import * as core from '../../../../../../../core'

import { query } from './outcomes-table.query'

export const RESOURCE = {
  payload: {
    alias: 'summit.outcomes-table',
    description:
      "Table used to explore the institution's goals, objectives, and other outcomes",
    name: 'Summit - Outcomes Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
